var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs, _mask, _g, _defs2, _g2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProspectMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 208 367",
    style: {
      enableBackground: "new 0 0 208 367"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A9553E;}\n\t.st1{fill:#010101;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st4{mask:url(#mask0_1074_5015_00000011742190484554488810000016906138887255965614_);}\n\t.st5{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter_00000117652642376192315180000008555487595237913021_);}\n\t.st6{mask:url(#mask1_1074_5015_00000098197726558461800030000005413302198633010068_);}\n\t.st7{fill:#F5B4C8;}\n\t.st8{fill:#D8E3F5;}\n\t.st9{fill:#5771B5;}\n\t.st10{fill:#FDC749;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.4,54.8L79,63.7l9.4,3.9V56.7L79.4,54.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.3,58.2l0.1-3.4l9.1,1.9v6.6C85.1,62.8,81.4,60,79.3,58.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.5,49.7c1.8-1,3.9-0.6,4.9,1c0.9,1.6,0.3,3.7-1.5,4.7c-1.8,1-3.9,0.6-4.9-1C95.1,52.8,95.8,50.7,97.5,49.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.8,52.9C97.8,52.9,97.8,52.9,97.8,52.9l3.5-0.3c0.2,0,0.4-0.2,0.3-0.4c0-0.2-0.2-0.4-0.4-0.3l-3.5,0.3 c-0.2,0-0.4,0.2-0.3,0.4C97.4,52.7,97.6,52.9,97.8,52.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.2,54.6C99.2,54.6,99.2,54.6,99.2,54.6c0.3,0,0.4-0.2,0.4-0.4l-0.3-1.6c0-0.2-0.2-0.3-0.4-0.3 c-0.2,0-0.3,0.2-0.3,0.4l0.3,1.6C98.9,54.5,99,54.6,99.2,54.6L99.2,54.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.5,42.9c-0.2-2-1.9-3.5-3.7-3.3c-1.8,0.2-3.1,2-2.9,4.1c0.2,2,1.9,3.5,3.7,3.3C76.4,46.8,77.7,45,77.5,42.9z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,44.8c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.2-0.3,0.1-0.5l-1.8-3c-0.1-0.2-0.3-0.2-0.5-0.1 c-0.2,0.1-0.2,0.3-0.1,0.5l1.8,3C74.9,44.7,75,44.8,75.1,44.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.9,44.7c0.1,0,0.1,0,0.2,0l1.5-0.8c0.2-0.1,0.3-0.3,0.2-0.5c-0.1-0.2-0.3-0.3-0.5-0.2L72.7,44 c-0.2,0.1-0.3,0.3-0.2,0.5C72.6,44.6,72.8,44.7,72.9,44.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.8,51.4c3.2-7.6-0.3-13.9-6.5-16.4C86,32.4,79,34.5,76.1,42.2c-2.7,7.4,0.3,13.7,6.5,16.4 C90.1,61.8,96.1,57.9,98.8,51.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.9,48.2C89.9,48.2,89.9,48.2,89.9,48.2c0.3,0,0.4-0.2,0.4-0.4l-0.6-3.5c0-0.1-0.1-0.2-0.2-0.3 c-0.1,0-0.3,0-0.4,0l-2.8,2.2c-0.2,0.1-0.2,0.4-0.1,0.5c0.1,0.2,0.4,0.2,0.5,0.1l2.4-1.8l0.5,2.9C89.6,48.1,89.7,48.3,89.9,48.2 L89.9,48.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.6,45.2c0,0-0.5-8.2-6.5-5.6C79.2,39.6,79.4,47.2,85.6,45.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.8,47c0,0,6-5,8,1.1C98.8,48.1,93.6,53,90.8,47z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,43.7c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4c-2.9,0-3.8-1.4-3.9-1.5c-0.1-0.2-0.3-0.2-0.5-0.1 s-0.2,0.3-0.1,0.5C92.9,41.9,94,43.7,97.3,43.7L97.3,43.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.8,39.4c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.2-0.4,0-0.5c-0.1-0.1-2.1-2.2-5.7-1.4c-0.2,0-0.3,0.2-0.3,0.4 s0.2,0.3,0.4,0.3c3.2-0.7,5,1.2,5,1.2C87.6,39.4,87.7,39.4,87.8,39.4L87.8,39.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.7,48.7c-2.8-11.5-9.7-13-11.2-15c-0.6-1.6,1.3-1.9,4.1-1C99.4,34.8,103.2,41.3,99.7,48.7z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 81,
    y: 39.4,
    width: 6,
    height: 6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 39.4,
    width: 6,
    height: 6,
    id: "mask0_1074_5015_00000011742190484554488810000016906138887255965614_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.6,45.2c0,0-0.5-8.2-6.5-5.6C79.2,39.6,79.4,47.2,85.6,45.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,42.4c0,1.7,1.3,3,3,3c1.7,0,3-1.4,3-3s-1.3-3-3-3C82.4,39.4,81,40.8,81,42.4z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000054945020754934953490000009809720501357478832_",
    filterUnits: "userSpaceOnUse",
    x: 92.4,
    y: 44,
    width: 6,
    height: 6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 92.4,
    y: 44,
    width: 6,
    height: 6,
    id: "mask1_1074_5015_00000098197726558461800030000005413302198633010068_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      filter: "url(#Adobe_OpacityMaskFilter_00000054945020754934953490000009809720501357478832_)"
    },
    d: " M90.8,47c0,0,6-5,8,1.1C98.8,48.1,93.6,53,90.8,47z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.4,47c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3s-1.3-3-3-3C93.8,44,92.4,45.3,92.4,47z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,41.5c0.8-10.1,10.7-11.2,13.3-7.5C87.3,34.5,81.3,35.6,76.5,41.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.3,51.2c0.1,0,0.2,0.1,0.3,0.2c0,0,2.2,1.7,3.4,2.4c0.3,0.2,0.5,0.3,0.7,0.3c0-0.1-0.1-0.2-0.1-0.3 c-0.1-0.2-0.1-0.5,0.1-0.6c0.2-0.1,0.5-0.1,0.6,0.1c0.2,0.4,0.6,1.1,0.2,1.5c-0.4,0.4-1.2,0.1-1.9-0.3c-1.4-0.8-3.6-2.6-3.7-2.7 c-0.1-0.2-0.1-0.5,0.1-0.6C83.1,51.2,83.2,51.2,83.3,51.2L83.3,51.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.9,314.4l9.4,38.7l19.6-4.4l-5.8-35.7L128.9,314.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.8,318.4l-0.8-5.4l-23.2,1.4l2.4,9.9L152.8,318.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.1,320.1l5.6,42.7l19.8-0.2l-2.2-42.8L56.1,320.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.3,329.7l22.6,1.6l-0.6-11.5l-23.3,0.3L57.3,329.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.4,317.3l1.2,9.8l24.9-1.6l-1-11.2L54.4,317.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M127,309.8l2.2,9.7l24.6-4.1l-2.1-11L127,309.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80.7,337.5l7.4,28.7H38.2l-0.5-6.2c-0.7-7.9,5.4-13.8,13.7-15l8.2,0l10.6,2.2L80.7,337.5L80.7,337.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M58.7,346.5l-4.3-5.9c-1.3-1.8-0.2-4.3,2.1-4.6l6.4-0.8c2.1-0.3,3.8,1.4,3.5,3.4l-1.4,8.9L58.7,346.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.7,360.9h48c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4h-48c-0.2,0-0.4,0.2-0.4,0.4 C37.3,360.7,37.5,360.9,37.7,360.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.5,348.4c0.2,0,0.3-0.1,0.4-0.2c0.1-0.2,0-0.4-0.2-0.5l-8.8-4.9l14.2,4.6c0.2,0.1,0.4,0,0.5-0.2 c0.1-0.2,0-0.4-0.2-0.5l-17.8-5.7c-0.2-0.1-0.4,0-0.5,0.2c-0.1,0.2,0,0.4,0.2,0.5l9.4,5.2l-9.1-2.5c-0.2,0-0.4,0.1-0.5,0.3 c-0.1,0.2,0.1,0.4,0.3,0.5L57.5,348.4C57.4,348.4,57.5,348.5,57.5,348.4L57.5,348.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M133.6,340.6l6.1,24.2l55.6-22.8l-2.9-7.3c-2-5-7.4-7.8-13-6.7l-23.3,4.5l-11.4,8.7L133.6,340.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.8,336.1l-3.9-6.2c-1.2-1.9,0.2-4.4,2.5-4.6l6.5-0.7c2.1-0.2,3.7,1.5,3.3,3.5l-2.1,9.1L151.8,336.1 L151.8,336.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139,359.1c0,0,0.1,0,0.1,0l54.2-22.4c0.2-0.1,0.3-0.3,0.2-0.5c-0.1-0.2-0.3-0.3-0.5-0.2l-54.2,22.4 c-0.2,0.1-0.3,0.3-0.2,0.5C138.7,359,138.9,359.1,139,359.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.6,335.5c0.1,0,0.1,0,0.1,0l11.7-5.2l-1.3,3.7c-0.1,0.2,0,0.4,0.2,0.5c0.2,0.1,0.4,0,0.5-0.2l1.6-4.5 c0.1-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.3-0.1-0.4-0.1l-7.8,3.5l5.2-3.2c0.2-0.1,0.2-0.3,0.1-0.5c-0.1-0.2-0.3-0.2-0.5-0.1l-9.5,6 c-0.2,0.1-0.2,0.3-0.1,0.5C156.3,335.5,156.4,335.5,156.6,335.5L156.6,335.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.8,124.4c0,0-7.4,15.2-8.4,39.3S36,313.7,55.1,318.1l24.9-1.6c0,0,12.5-4.6,9.3-32.4 c-3.1-27.7-15.6-111-15.6-111l3.9,0.7c0,0,28,100,34.5,120.9c5.5,17.8,16.2,17.2,16.2,17.2l24.5-4.4c0,0,10.3-3.8,1.5-28.7 s-49-145.5-49-145.5L46.8,124.4L46.8,124.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.8,62.3c0,0,14.4,1.9,23.2,1.9l-0.4,12.9L76,77.6L74.8,62.3L74.8,62.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M77.8,62.3c0,0-28.5-7.9-38.5,6c-9.5,13.2-13.6,31.6-13.6,31.6l31.9,9.9v10.9c0,0,44.2-7,44-6.2 c-0.2,0.8,30.8,6,30.8,6s2.7-22.1,2.7-31.5s-3.2-23.6-19.7-23.6c-8.2,0-21-1.6-21-1.6s-1,11.2-9.6,10.1 C77.3,72.8,77.8,62.3,77.8,62.3L77.8,62.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,101.3c0,0-1.6,14-1.9,20.6c-0.3,8.6,1.8,23.8,13.5,26.8s22.4-2.2,30.7-7.2s35.4-16.8,35.4-16.8l-6.2-20.3 l-44.1,14.7l-0.3-9.4L30.5,101.3L30.5,101.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.3,116.4c0,0-3.2,13.5-9.2,24.6c-6,11.1-13.2,16.8-21.6,15.3c-8.4-1.5-19.4-18.4-19.4-58.8 c0-11.2,2-18,2-18l11.5-1.1l11.9,37.3L131.3,116.4L131.3,116.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.4,103.6c0.2,0,0.4-0.1,0.5-0.4l3.5-12c0.1-0.3-0.1-0.5-0.3-0.6c-0.3-0.1-0.5,0.1-0.6,0.3l-3.5,12 c-0.1,0.3,0.1,0.5,0.3,0.6C103.3,103.6,103.3,103.6,103.4,103.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.6,89c0.2,0,0.3-0.1,0.4-0.2L122.6,67c0.2-0.2,0.1-0.5-0.1-0.7c-0.2-0.2-0.5-0.1-0.7,0.1l-14.6,21.8 c-0.2,0.2-0.1,0.5,0.1,0.7C107.4,89,107.5,89,107.6,89L107.6,89z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.5,84.8c0.1,0,0.1,0,0.2,0c0.2-0.1,0.4-0.4,0.3-0.7l-9.3-22.2c-0.1-0.2-0.4-0.4-0.7-0.3 c-0.2,0.1-0.4,0.4-0.3,0.7L57,84.5C57.1,84.7,57.3,84.8,57.5,84.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,175.7c0.2,0,0.4-0.2,0.5-0.4c0.1-0.3-0.1-0.5-0.4-0.6l-13.8-3c-0.3,0-0.5,0.1-0.6,0.4 c-0.1,0.3,0.1,0.5,0.4,0.6l13.8,3C81.8,175.7,81.9,175.7,81.9,175.7L81.9,175.7z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.8,110.4c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.4L59,95.5c0-0.3-0.2-0.5-0.5-0.5 c-0.3,0-0.5,0.2-0.5,0.5l-0.7,13.8l-26.9-8c-0.3-0.1-0.5,0.1-0.6,0.3c-0.1,0.3,0.1,0.5,0.3,0.6l27.5,8.2 C57.6,110.4,57.7,110.4,57.8,110.4L57.8,110.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.5,135.5c0,0,0.1,0,0.1,0c0.3-0.1,0.4-0.4,0.3-0.6c-2.8-10-3.9-23.5-3.9-23.6c0-0.3-0.3-0.5-0.5-0.5 c-0.3,0-0.5,0.3-0.5,0.5c0,0.1,1.1,13.7,3.9,23.8C85.1,135.3,85.3,135.5,85.5,135.5L85.5,135.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.3,105.1l3.2-1c0,0,12.1-7.2,22.8-4.6c10.7,2.6,2.9,6.2,2.9,6.2s-5.4,16.8-10.9,19.4 c-1.8,0.9-13.5-1.9-13.5-1.9L103.3,105.1L103.3,105.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.7,104.7l-10.8-3c-1.8-0.5-3.7,0.6-4.2,2.4c-0.5,1.9,0.6,3.8,2.5,4.2l11,2.2c1.6,0.3,3.2-0.8,3.5-2.4 C138,106.6,137.1,105.2,135.7,104.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,116.9l-13.1-2.9c-1.4-0.3-2.4-1.6-2.4-3.1v-0.3c0.1-2,1.9-3.6,3.9-3.1l13.1,3.2c1.6,0.4,2.6,1.9,2.3,3.6 C136.6,116.1,134.9,117.2,133.1,116.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.4,119.6c0.2-1.4-0.7-2.6-2-3l-8.6-2.2c-1.4-0.4-2.9,0.4-3.4,1.7l-0.3,0.7c-0.7,1.6,0.3,3.4,2,3.7l8.9,1.6 C131.6,122.3,133.2,121.2,133.4,119.6L133.4,119.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.8,123.7c0-1.1-0.7-2-1.7-2.2l-7.1-1.7c-1.2-0.3-2.3,0.5-2.6,1.8l-0.2,0.8c-0.3,1.4,0.6,2.7,1.9,2.9 l7.3,0.9C128.7,126.3,129.9,125.2,129.8,123.7L129.8,123.7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.5,115.6c-0.2-0.1-0.3-0.3-0.2-0.5c0.1-0.2,0.3-0.3,0.5-0.2c0.4,0.1,5.6,1.4,8.2,2c0.2,0,0.3,0.2,0.3,0.4 c-0.1,0.2-0.3,0.3-0.5,0.3C132.5,117.5,125.1,115.8,124.5,115.6L124.5,115.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.1,109.6c-0.2-0.1-0.3-0.3-0.2-0.5c0.1-0.2,0.3-0.3,0.5-0.2c0.5,0.1,6.4,1.5,9.6,2.1c0.2,0,0.3,0.2,0.3,0.4 s-0.3,0.3-0.5,0.3C135.3,111.7,126.7,109.8,126.1,109.6L126.1,109.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.4,120.9c-0.2-0.1-0.3-0.3-0.2-0.5c0.1-0.2,0.3-0.3,0.5-0.2c0.6,0.2,5,1.1,7.2,1.6c0.2,0,0.3,0.2,0.3,0.4 c-0.1,0.2-0.3,0.3-0.5,0.3C129.4,122.5,123.1,121.2,122.4,120.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.3,101.9c-0.3-0.1-0.6-0.3-0.6-0.5c0-0.2,0.4-0.3,0.8-0.2l9.5,2.5c0.4,0.1,0.7,0.3,0.6,0.6 s-0.4,0.3-0.8,0.2L124.3,101.9C124.4,102,124.3,102,124.3,101.9L124.3,101.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.1,126.5c0.5,0,1,0,1.4,0c0.3,0,0.5-0.3,0.5-0.5c0-0.3-0.3-0.5-0.5-0.5c-6,0.4-18.3-2.3-20.3-2.7l-5.6-21.5 c-0.1-0.3-0.3-0.4-0.6-0.4c-0.3,0.1-0.4,0.3-0.4,0.6l5.7,21.8c0.1,0.2,0.2,0.3,0.4,0.4C108.2,123.7,120.1,126.5,127.1,126.5 L127.1,126.5z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.1,68.8l-6.2-2.9c-2.2-1-4.8-0.6-6.4,1.2l-5.1,5.3c-0.5,0.5-0.7,1.2-0.6,1.8l0.5,4.4 c0.1,1.1,0.9,2.1,1.9,2.5l4,1.6L93.1,68.8L93.1,68.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.2,95.8l11-3.6c0,0-2.2-7.5-2.2-18c0-4.7-4.6-11.6-8.1-16.8c-1.3-1.9-2.1-3.4-3.3-3.7 c-1.6-0.4-3.5,1.6-2.3,3.7c3.3,5.5,7.6,12.6,7.6,12.6s0,0.1,0,0.2c-3,0.5-6.6,1.9-8.4,7.7C78.5,88.2,87.2,95.8,87.2,95.8L87.2,95.8z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.7,69.6l-6.2-2.9c-2.2-1-4.8-0.6-6.4,1.2L76,73.1c-0.5,0.5-0.7,1.2-0.6,1.8l0.5,4.4c0.1,1.1,0.9,2.1,1.9,2.5 l4,1.6L93.7,69.6L93.7,69.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.8,96.6l11-3.6c0,0-2.2-7.5-2.2-18c0-4.7-4.6-11.6-8.1-16.8c-1.3-1.9-2-3.3-3.3-3.7 c-1.6-0.4-3.5,1.5-2.3,3.7c3.3,5.5,7.6,12.6,7.6,12.6s0,0.1,0,0.2c-3,0.5-6.6,1.9-8.4,7.7C79.1,88.9,87.8,96.6,87.8,96.6L87.8,96.6z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.4,73.3c0.1,0,0.2,0,0.3-0.2c0.1-0.2,0.1-0.4-0.1-0.5c-6.6-4.9-8.6-4.3-8.8-4.2c-0.2,0.1-0.3,0.3-0.2,0.5 c0.1,0.2,0.3,0.3,0.5,0.2c0.1,0,2-0.4,8.1,4.1C88.3,73.2,88.4,73.3,88.4,73.3L88.4,73.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.6,76.6c0.1,0,0.2-0.1,0.3-0.2c0.1-0.2,0.1-0.4-0.1-0.5c-6.2-4.3-8.2-4.1-8.4-4c-0.2,0-0.3,0.2-0.3,0.4 c0,0.2,0.2,0.3,0.4,0.3c0.1,0,2-0.2,7.8,3.9C84.5,76.6,84.6,76.6,84.6,76.6z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.3,83.9c0.2,0,0.4-0.2,0.4-0.3l0.2-3.6c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.4l-0.2,3.6 C80.9,83.7,81.1,83.9,81.3,83.9L81.3,83.9L81.3,83.9z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82,80.4c0.1,0,0.2-0.1,0.3-0.2c0.1-0.2,0.1-0.4-0.1-0.5L78,77.2c-0.2-0.1-0.4-0.1-0.5,0.1 c-0.1,0.2-0.1,0.4,0.1,0.5l4.2,2.6C81.9,80.4,81.9,80.4,82,80.4L82,80.4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.4,81c0.5,0,1-0.3,1.4-0.8c0.4-0.5,0.6-1,0.5-1.5c0-0.2-0.2-0.3-0.4-0.3c-0.2,0-0.3,0.2-0.3,0.4 c0,0.2-0.1,0.6-0.3,0.9c-0.2,0.3-0.6,0.5-0.8,0.5c-0.2,0-0.4,0.2-0.4,0.4C78,80.8,78.2,81,78.4,81L78.4,81z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.8,72.9C93.8,72.9,93.8,72.9,93.8,72.9c0.2,0,0.4-0.2,0.4-0.4c-0.2-3.1-6-6.2-6.3-6.3 c-0.2-0.1-0.4,0-0.5,0.2c-0.1,0.2,0,0.4,0.2,0.5c1.6,0.8,5.8,3.5,5.9,5.7C93.4,72.7,93.6,72.9,93.8,72.9L93.8,72.9z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1,366.8h205.6c0.6,0,1-0.4,1-1c0-0.5-0.4-1-1-1H1c-0.6,0-1,0.5-1,1C0,366.3,0.4,366.8,1,366.8z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117.3,47.9c0,1.2-1.2,2.1-2.8,2.1c-1.5,0-2.8-0.9-2.8-2.1c0-1.2,1.2-2.1,2.8-2.1 C116.1,45.8,117.3,46.7,117.3,47.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.3,47.9c0-1.4,1.5-2.6,3.2-2.6s3.2,1.2,3.2,2.6c0,1.4-1.5,2.6-3.2,2.6S111.3,49.3,111.3,47.9z M112.3,47.9 c0,0.9,1,1.6,2.2,1.6s2.2-0.7,2.2-1.6s-1-1.6-2.2-1.6S112.3,47,112.3,47.9z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M123.7,43.5c2.3,0,4.2-1.4,4.2-3.2c0-1.8-1.9-3.2-4.2-3.2c-2.3,0-4.2,1.4-4.2,3.2 C119.5,42.1,121.4,43.5,123.7,43.5z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119,40.3c0-2.1,2.1-3.7,4.7-3.7s4.7,1.7,4.7,3.7s-2.1,3.7-4.7,3.7S119,42.3,119,40.3z M120,40.3 c0,1.5,1.7,2.7,3.7,2.7s3.7-1.2,3.7-2.7s-1.7-2.7-3.7-2.7S120,38.8,120,40.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M148.4,40.3c15.3,0,27.7-8.9,27.7-19.9c0-11-12.4-19.9-27.7-19.9c-15.3,0-27.7,8.9-27.7,19.9 C120.6,31.4,133.1,40.3,148.4,40.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.1,20.4C120.1,9.1,132.8,0,148.4,0s28.2,9.1,28.2,20.4s-12.7,20.4-28.2,20.4S120.1,31.6,120.1,20.4z  M121.1,20.4c0,10.7,12.2,19.4,27.2,19.4s27.2-8.7,27.2-19.4C175.6,9.7,163.4,1,148.4,1S121.1,9.7,121.1,20.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectMen);
export default __webpack_public_path__ + "static/media/prospect-men.cab51c23.svg";
export { ForwardRef as ReactComponent };